export const Transactions = {
    LOADING_TRANSACTIONS_LIST: "LOADING_TRANSACTIONS_LIST",
    GET_TRANSACTIONS_LIST: "GET_TRANSACTIONS_LIST",
  };